// extracted by mini-css-extract-plugin
export default {"carousel__wrapper":"Sv","carousel__wrapper_on_sides":"Tv","arrows_wrapper":"Uv","arrows_wrapper_right":"Vv","arrows_wrapper_vertical":"Wv","arrows_wrapper_on_sides":"Xv","arrow_button":"Yv","carousel_arrow_left":"Zv","carousel_arrow_left_on_side":"aw","carousel_arrow_right_on_side":"bw","carousel_arrow":"cw","arrows_wrapper_rounded":"ew","carousel__fullWidth":"fw"};
    if(module.hot) {
      // 1711394576398
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  